/**
 * SCRUM-92 (DS-008-9) — open-ownership.schema.ts
 *
 * Zod schema for POST /organizations/:slug/properties/:propertyId/ownership
 * request body (endpoint #1). Validates structure only — business rules
 * (future-dated check, non-100 share in Lite) are enforced by the UC layer.
 */
import { z } from 'zod';
export const openOwnershipSchema = z.object({
    userId: z.string().uuid(),
    /** Share percentage: 1–100 (integer). UC rejects non-100 in Lite mode. */
    share: z.number().int().min(1).max(100),
    /** ISO 8601 datetime string. Schema accepts future-dated; UC enforces Lite restriction. */
    effectiveFrom: z.string().datetime(),
    contractName: z.string().nullable().optional(),
    contractReference: z.string().nullable().optional(),
    expiresAt: z.string().datetime().nullable().optional(),
});
//# sourceMappingURL=open-ownership.schema.js.map